var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2755_4766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2755_4766)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#1C9975"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2755_4766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2755_4766)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5155 6.56819L10.3412 7.51337L10.6091 5.66894L9.63123 4.28857L10.9553 4.21394L11.5155 2.4917L12.0757 4.21394H13.3975L12.4219 5.66894L12.7156 7.51337L11.5155 6.56819Z",
    fill: "#FECA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18125 7.26862L7.45519 7.85305L7.6208 6.7126L7.01617 5.85909L7.83487 5.81294L8.18125 4.74805L8.52762 5.81294H9.34492L8.74169 6.7126L8.9233 7.85305L8.18125 7.26862Z",
    fill: "#FECA00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7926 7.26862L14.0665 7.85305L14.2321 6.7126L13.6275 5.85909L14.4462 5.81294L14.7926 4.74805L15.1389 5.81294H15.9563L15.353 6.7126L15.5346 7.85305L14.7926 7.26862Z",
    fill: "#FECA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3009 9.21018L5.71826 9.67917L5.85116 8.76399L5.36597 8.07908L6.02295 8.04204L6.3009 7.1875L6.57886 8.04204H7.23472L6.75064 8.76399L6.89638 9.67917L6.3009 9.21018Z",
    fill: "#FECA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9343 9.21018L16.3517 9.67917L16.4846 8.76399L15.9994 8.07908L16.6564 8.04204L16.9343 7.1875L17.2123 8.04204H17.8681L17.3841 8.76399L17.5298 9.67917L16.9343 9.21018Z",
    fill: "#FECA00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2755_4766",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 13,
    height: 17
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 21.0833C14.6756 21.0833 17.25 17.6509 17.25 13.4167C17.25 9.18248 14.6756 5.75 11.5 5.75C8.32436 5.75 5.75 9.18248 5.75 13.4167C5.75 17.6509 8.32436 21.0833 11.5 21.0833Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2755_4766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07079 22.3083H6.26428V17.2696L9.06574 17.2696C10.0581 17.251 10.7833 16.8731 11.2671 16.146L11.5082 15.7837L11.7773 16.109C12.4235 16.8902 13.069 17.2696 13.722 17.2696H16.8156V22.3083H13.722C12.9718 22.3083 12.2476 21.932 11.5551 21.1953C10.9418 21.9201 10.109 22.2888 9.07079 22.3083Z",
    fill: "#F7FCFF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5249 7.29102C11.5249 7.29102 10.2968 8.90868 10.2968 11.1287C10.2968 11.6038 10.353 12.0527 10.4414 12.4647C10.0457 11.2954 10.0183 10.0275 10.3598 8.64442L9.89499 8.44038C9.5476 9.84736 9.5461 11.1702 9.89099 12.3961C9.17754 11.823 8.35671 11.4379 7.5142 11.3137L7.46043 11.9622C8.19673 12.0707 8.91539 12.3981 9.54635 12.8827C9.39057 12.7989 9.22723 12.7261 9.05682 12.6681C7.5022 12.1391 5.97699 12.8892 5.97699 12.8892C5.97699 12.8892 6.8568 15.521 8.56088 15.9091C8.64584 15.9284 8.72983 15.9435 8.81273 15.9547L8.79986 15.9547C7.98739 15.9547 7.23183 15.5118 6.52431 14.612L6.18654 15.0841C6.98124 16.0948 7.85531 16.6072 8.79986 16.6072C9.72363 16.6072 10.5816 16.1171 11.3655 15.1501C11.4912 15.0489 11.5648 14.9764 11.5766 14.9646L11.6074 14.9996C11.5913 15.0366 11.5832 15.0568 11.5832 15.0568C11.5832 15.0568 11.6605 15.1192 11.7998 15.2071C12.5739 16.007 13.5423 16.6072 14.3085 16.6072C15.2531 16.6072 16.1271 16.0948 16.9218 15.0841L16.5841 14.612C15.8765 15.5118 15.121 15.9547 14.3085 15.9547C14.0117 15.9547 13.7208 15.8911 13.4355 15.7632C13.835 15.7918 14.2752 15.7439 14.7307 15.5581C16.4093 14.8739 17.1091 12.8042 17.1091 12.8042C17.1091 12.8042 16.2159 12.1617 15.0815 12.1544C15.3357 12.067 15.6009 12.003 15.8775 11.9622L15.8237 11.3137C14.7598 11.4705 13.8393 11.9493 13.0672 12.7482C13.5186 11.4246 13.5536 9.9831 13.1727 8.44038L12.7079 8.64442C13.0191 9.90505 13.0239 11.07 12.7227 12.1518C12.7743 11.832 12.8048 11.49 12.8048 11.1287C12.8048 8.78835 11.5249 7.29102 11.5249 7.29102ZM12.0652 14.1408L12.047 14.1758L12.0692 14.1405L12.0652 14.1408ZM10.8782 13.988L10.9263 13.929C10.97 14.0259 11.0136 14.1171 11.0563 14.2022C11.001 14.1328 10.9416 14.061 10.8782 13.988Z",
    fill: "#F7FCFF"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2755_4766)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2755_4766",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMop);
export default __webpack_public_path__ + "static/media/MOP.dca61ab0d948bc11887f1b5ea18d3c77.svg";
export { ForwardRef as ReactComponent };